import React from "react";
import {observer} from "mobx-react-lite";
import {Stack, TableRow} from "@mui/material";
import {CurrencyComponent} from "../../../../components/currency-component/CurrencyComponent";
import {CurrencyAbbreviationContext} from "../../../../components/currency-component/CurrencyAbbreviationContext";
import type {ParentSupplierReviewRow, SupplierReviewRow} from "../SupplierNormalization.classes";
import {getParentSupplierChoice} from "../SupplierNormalization.classes";
import {getSupplierNormalizationSupplierColumns} from "./columns";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../../../constants";
import {ParentSupplierChooser} from "../components/ParentSupplierChooser";
import {MithraTableCell} from "../../../../components/table/MithraTableCell";
import {useStores} from "../../../../stores";
import {GoogleLink} from "../../../../components/_tiny/GoogleLink";
import {EditLinkWrapper} from "../../../../components/linking/EditLinkWrapper";
import {useSearchParams} from "react-router";
import * as CategorizationReviewUrls from "../../../categorization/classes/CategorizationReviewUrls";
import {getSupplierIdHack} from "../../../../stores/hacks/display.ts";

type Props = {
    supplier: SupplierReviewRow,
    parentSupplier: ParentSupplierReviewRow,
};
export const ParentSupplierReviewSubRow: React.FC<Props> = observer(({supplier, parentSupplier}) => {
    const {p, bagStore, authStore} = useStores();
    const [searchParams] = useSearchParams();
    const categorizationEditUrl = CategorizationReviewUrls.intentToURL(
        CategorizationReviewUrls.buildPath(bagStore.bagId),
        searchParams,
        {type: 'by_supplier', supplier: supplier.supplier.s_name},
    )
    const SUPPLIER_COLUMNS = getSupplierNormalizationSupplierColumns(p, authStore);
    let i = 0;

    const _parent_supplier = p.p.parentSupplierAltName ?? 'Parent Supplier';
    return <TableRow className="sub-row">
        <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
            <Stack direction="row" className="supplier-parent-chooser-wrapper">
                <ParentSupplierChooser
                    supplier={supplier}
                    parentSupplierChoice={getParentSupplierChoice(parentSupplier)}
                    label={_parent_supplier}/>
            </Stack>
        </MithraTableCell>
        {p.p.showSupplierIdInSupplierNormalization &&
            <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
                {getSupplierIdHack(supplier.supplier)}
            </MithraTableCell>
        }
        <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
            <GoogleLink type="supplier" objs={[supplier.supplier]}>
                {supplier.supplier.s_name}
            </GoogleLink>
        </MithraTableCell>
        <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
            <CurrencyAbbreviationContext.Consumer>{abbreviation =>
                <CurrencyComponent v={supplier.s_total_spend} abbreviation={abbreviation}/>
            }</CurrencyAbbreviationContext.Consumer>
        </MithraTableCell>
        {p.p.showSupplierCountryInSupplierNormalization &&
            <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
                {supplier.supplier.s_country_code}
            </MithraTableCell>
        }
        <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
            {supplier.supplier.s_city
                || supplier.supplier.s_country
                || supplier.supplier.s_address
                || supplier.supplier.s_country_code
                || supplier.supplier.s_region}
        </MithraTableCell>
        {p.p.showBusinessUnitInSupplierNormalization &&
            <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
                {supplier.s_total_bus.map(l => l === null ? 'None' : l).join(', ')}
            </MithraTableCell>
        }
        {p.p.showSupplierVatInSupplierNormalization &&
            <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
                {supplier.supplier.s_vat || '-'}
            </MithraTableCell>
        }
        <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
            <EditLinkWrapper
                link={categorizationEditUrl}
                hasEditPermission={authStore.hasEditPermission}
                tooltip={`Edit the category of this ${p.supplierDataName.toLowerCase()}. Updates will reflected the next day`}
                noEditPermTooltip={`See the category of this ${p.supplierDataName.toLowerCase()} in the review page`}>
                {supplier.s_total_l1s.map(l => l === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : l).join(', ')}
            </EditLinkWrapper>
        </MithraTableCell>
        {authStore.isMithraStaffGroup &&
            <MithraTableCell c={SUPPLIER_COLUMNS[i++]}>
                {'' + supplier.review_user_id}
            </MithraTableCell>
        }
        {/*<MithraTableCell c={SUPPLIER_COLUMNS[i++]}>*/}
        {/*    {Math.round(supplier.s_suggestion_score)}*/}
        {/*</MithraTableCell>*/}
    </TableRow>
})
